// City values arrive as URL/cookie slugs (e.g. "new-delhi") in many places
// that also render them as user-facing text (page titles, breadcrumbs,
// city cards). This turns a slug into a display-friendly label
// ("New Delhi") — hyphens become spaces and each word is capitalized.
export const formatCityName = (value) => {
  if (!value) return "";
  return String(value)
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
